export enum _BotOperationsEnum {
  DEPOSIT = "DEPOSIT",
  CHECK_BALANCE = "CHECK_BALANCE",
  AMOUNT = "AMOUNT",
  CURRENCY = "CURRENCY",
  ACCOUNT = "ACCOUNT",
  WITHDRAW = "WITHDRAW",
  DOWNLOAD = "DOWNLOAD",
  LEARN_MORE = "LEARN_MORE",
  EXPLORE = "EXPLORE",
  SCHEDULE = "SCHEDULE",
  VIEW_USE_CASE = "VIEW_USE_CASE",
  REQUEST_A_CALL = "REQUEST_A_CALL",
  CHANGE_PASSWORD = "CHANGE_PASSWORD",
  SIGN_OUT = "SIGN_OUT",
  CHOOSE_TIME = "CHOOSE_TIME",
  START = "START",
  EMAIL = "EMAIL",
  FEEDBACK = "FEEDBACK",
  SUCCESSFUL_PAYMENT = "SUCCESSFUL_PAYMENT",
  BOT_MESSAGE = "BOT_MESSAGE",
}

export enum AuthBotOperationsEnum {
  DEPOSIT = "DEPOSIT",
  WITHDRAW = "WITHDRAW",
  CHECK_BALANCE = "CHECK_BALANCE",
  CHAT_WITH_AGENT = "CHAT_WITH_AGENT",
  SIGN_OUT = "SIGN_OUT",
}

export enum NoAuthBotOperationsEnum {
  LOGIN = "LOGIN",
}

export enum OptionType {
  url = "url",
  web_app = "web_app",
  callback_data = "callback_data",
}
